import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import './RenameDesign.scss';

const RenameDesign = ({
  artworkInfo: {
    name,
    preview_urls: { large: previewUrl },
  },
  setDesignName,
  designName,
}) => {
  const { current: imageHash } = useRef(Date.now());
  const nameInputRef = useRef();

  const setCursorPosition = useCallback(() => {
    const { current = {} } = nameInputRef;
    current.selectionStart = designName.length;
    current.selectionEnd = designName.length;
    current.focus();
  }, [designName]);

  useEffect(setCursorPosition, []);

  const onNameChanged = ({ target: { value = '' } }) => {
    const name = value.replace(/(\s)\s+/, '$1');
    setDesignName(name);
  };

  return (
    <div id="rename-zone">
      <div>
        <div className="rename-title">
          <LocalizedText id="qau-rename-title" />
        </div>
        <input type="text" name="renameDesign" ref={nameInputRef} value={designName || ''} onChange={onNameChanged} />
      </div>
      <div className="artwork-preview">
        <img src={`${previewUrl}?hash=${imageHash}`} alt="Artwork Preview" />
      </div>
    </div>
  );
};

const mapStateToProps = ({ artwork }) => ({
  artworkInfo: artwork.info,
});

RenameDesign.propTypes = {
  artworkInfo: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(RenameDesign);
